import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from '../models/environment.token';
import { EnvironmentInterface } from '../models/environment.interface';
import { AuthApiService } from './auth-api.service';
import { UserProfile } from './models/user-profile.model';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class AuthStoreService {
  public userProfile: UserProfile; // TODO Make readonly
  public get isLoggedIn(): boolean {
    return Boolean(this.userProfile);
  }

  public constructor(@Inject(ENVIRONMENT) private environment: EnvironmentInterface, private authApiService: AuthApiService, private dialog: MatDialog, private localStorageService: LocalStorageService ) {}

  public signIn(): void {
    this.authApiService.loginWithSaml();
  }
  /*
  How signing out works:
  - First we need to log out from AWS Cognito. This is done by "authApiService.signOut(countryCode, languageCode)"
  - Afterwards Cognito will redirect to "redirectSignOutUrl: '/logout'" found in environment.ts
  - "/logout" will be on the default bundle, where we check for "/logout" in the url and need to logout from the IDP
   */
  public signOut(): Promise<void> {
    return this.authApiService.signOut();
  }
}
